// Keeps text and images out of section seams. A section with "Blend into the section above" slides up over the
// bottom of the section before it; when that section's content runs low (long text, mobile wrapping, a short
// padding setting), the blend would cover it. This measures the overlap and extends the section above just enough.
(() => {
  const SAFE = 16; // clear space kept between content and the blend
  const visible = (el) => !el.checkVisibility || el.checkVisibility({ opacityProperty: true, visibilityProperty: true });
  const contentBottom = (root) => {
    let max = -Infinity;
    for (const el of root.querySelectorAll('*')) {
      // decorative background art (aria-hidden) is meant to run into the blend; only real content counts
      if (el.closest('script, style, template, noscript, select, dialog:not([open]), details:not([open]) > :not(summary), [aria-hidden="true"], .itc-bg-art, .itc-edge-art')) continue;
      const isMedia = el.matches('img, svg, video, picture, button, input, textarea');
      if (!isMedia && ![...el.childNodes].some((n) => n.nodeType === 3 && n.textContent.trim())) continue;
      const r = el.getBoundingClientRect();
      if (r.width < 2 || r.height < 2 || !visible(el)) continue;
      max = Math.max(max, r.bottom);
    }
    return max;
  };

  const fit = () => {
    for (const blendEl of document.querySelectorAll('.itc-blend-top')) {
      const blend = parseFloat(getComputedStyle(blendEl).getPropertyValue('--blend')) || 0;
      const wrapper = blendEl.closest('.shopify-section');
      if (!blend || !wrapper) continue;
      let prev = wrapper.previousElementSibling;
      while (prev && prev.getBoundingClientRect().height < 1) prev = prev.previousElementSibling;
      if (!prev) continue;
      const target = prev.querySelector('.itc-section') || prev;
      // reset what we added last time, then measure
      if (target.dataset.itcSeamPad) { target.style.paddingBottom = ''; delete target.dataset.itcSeamPad; }
      const limit = blendEl.getBoundingClientRect().top + blend * 0.12 - SAFE;
      const need = Math.ceil(contentBottom(prev) - limit);
      if (need > 0) {
        const base = parseFloat(getComputedStyle(target).paddingBottom) || 0;
        target.style.paddingBottom = `${base + need}px`;
        target.dataset.itcSeamPad = need;
      }
    }
  };

  let queued = false;
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; fit(); }); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts) document.fonts.ready.then(schedule);
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(schedule);
    const watch = () => document.querySelectorAll('main .shopify-section').forEach((s) => ro.observe(s));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  }
})();
